module.exports = __webpack_public_path__ + "static/assets/cbde78d25a6b5091ba7b0847bfca5973.png";